/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import { format } from "date-fns";
import moment from "moment";

import { createMarkup } from "../../../utils";
import TableCell from "../../../components/TableCell";

export const CERTIFICATION_COLUMNS = [
  {
    Header: "Cert. Name",
    accessor: "CertificationName",
    id: "CertificationName"
  },
  {
    Header: "Cert. Type",
    accessor: "Type",
    Cell: ({ cell }) => (cell.value ? cell.value.CodeDescription : null)
  },
  {
    Header: "Last Test Date",
    accessor: "LastTestDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Expiration Date",
    accessor: "ExpirationDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Days To Expire",
    accessor: "DaysToExpire",
    Cell: ({ cell }) => cell.value
  },
  {
    Header: "Reference",
    accessor: "Reference"
  },
  {
    Header: "Note",
    accessor: "Note1",
    Cell: ({ cell }) => createMarkup(cell.value)
  }
];
export const NOTE_COLUMNS = [
  {
    Header: "Note Type",
    accessor: "NoteType",
    Cell: ({ cell }) => (cell.value ? cell.value.CodeDescription : null)
  },
  {
    Header: "Note",
    accessor: "Note",
    Cell: ({ cell }) =>
      createMarkup(cell.value ? cell.value.substr(0, 100) : "")
  },
  {
    Header: "Modified On",
    accessor: "ModifiedDateTime",
    Cell: ({ cell }) =>
      cell.value
        ? moment(cell.value)
            .add(4, "hours")
            .format("MM/DD/YYYY - hh:mm A")
        : null
  },
  {
    Header: "Modified By",
    accessor: "ModifiedBy"
  },
  {
    Header: "Created On",
    accessor: "CreatedDateTime",
    Cell: ({ cell }) =>
      cell.value
        ? moment(cell.value)
            .add(4, "hours")
            .format("MM/DD/YYYY - hh:mm A")
        : null
  },
  {
    Header: "Created By",
    accessor: "CreatedBy"
  }
];

export const EMPLOYEE_COLUMNS = [
  {
    Header: "Employee Id",
    accessor: "EmployeeId",
    sticky: "left"
  },
  {
    Header: "Last Name",
    accessor: "LastName"
  },
  {
    Header: "First Name",
    accessor: "FirstName"
  },
  {
    Header: "MI",
    accessor: "MiddleName"
  },
  {
    Header: "Active",
    accessor: "Active"
  },

  {
    Header: "Address 1",
    accessor: "Address1"
  },
  {
    Header: "Address 2",
    accessor: "Address2"
  },
  {
    Header: "City",
    accessor: "City"
  },
  {
    Header: "State",
    accessor: "State"
  },
  {
    Header: "Zip Code",
    accessor: "ZipCode"
  },
  {
    Header: "Home Phone No",
    accessor: "HomePhoneNo"
  },
  {
    Header: "Cell Phone No",
    accessor: "CellPhoneNo"
  },
  {
    Header: "Contact Preference",
    accessor: "ContactPreference.CodeDescription",
    id: "ContactPreference"
  },
  {
    Header: "Employee Type",
    accessor: "EmployeeType.CodeDescription"
  },
  {
    Header: "Driver Flag",
    accessor: "DriverFlag"
  },
  {
    Header: "Seniority Date",
    accessor: "SeniorityDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Seniority No",
    accessor: "SeniorityNo"
  },
  {
    Header: "Mechanic Flag",
    accessor: "MechanicFlag"
  },
  {
    Header: "Supervisor",
    accessor: "Supervisor",
    Cell: ({ cell }) =>
      cell.value ? `${cell.value.LastName}, ${cell.value.FirstName}` : null
  },
  {
    Header: "ELD Status",
    accessor: "ELDStatus.CodeDescription"
  },
  {
    Header: "Alternate Phone No",
    accessor: "AlternatePhoneNo"
  },
  {
    Header: "Emergency PhoneNo",
    accessor: "EmergencyPhoneNo"
  },
  {
    Header: "Emergency Contact",
    accessor: "EmergencyContact"
  },
  {
    Header: "Emergency Relationship",
    accessor: "EmergencyRelationship"
  },
  {
    Header: "Email 1",
    accessor: "Email1"
  },
  {
    Header: "Email 2",
    accessor: "Email2"
  },
  {
    Header: "Veteran",
    accessor: "Veteran"
  },
  {
    Header: "Ethnicity",
    accessor: "Ethnicity.CodeDescription"
  },
  {
    Header: "Payroll Id",
    accessor: "PayrollId"
  },
  {
    Header: "Hourly Rate",
    accessor: "HourlyRate",
    id: "HourlyRate",
    Cell: ({ cell }) => <TableCell.Currency value={cell.value} />
  },
  {
    Header: "Job Title",
    accessor: "JobTitle"
  },

  {
    Header: "Birth Date",
    accessor: "BirthDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Hire Date",
    accessor: "HireDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Termination Date",
    accessor: "TerminationDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Rehire Date",
    accessor: "RehireDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Vacation Days Allowed This Year",
    accessor: "VacationDaysAllowedThisYear"
  },
  {
    Header: "Vacation Days Renewal Date",
    accessor: "VacationDaysRenewalDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  // {
  //   Header: "Vacation Days Used This Year",
  //   accessor: "VacationDaysUsedThisYear"
  // },
  // {
  //   Header: "Vacation Days Balance",
  //   accessor: "VacationDaysBalance"
  // },
  {
    Header: "Personal Days Allowed This Year",
    accessor: "PersonalDaysAllowedThisYear"
  },
  {
    Header: "Personal Days Renewal Date",
    accessor: "PersonalDaysRenewalDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  // {
  //   Header: "Personal Days Used This Year",
  //   accessor: "PersonalDaysUsedThisYear"
  // },
  // {
  //   Header: "Personal Days Balance",
  //   accessor: "PersonalDaysBalance"
  // },
  {
    Header: "Drug Test",
    accessor: "DrugTest"
  },
  {
    Header: "Shop Steward",
    accessor: "ShopSteward"
  },
  {
    Header: "Home Company Location Id",
    accessor: "HomeCompanyLocationId"
  },

  {
    Header: "Last Worked Date",
    accessor: "LastWorkedDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Company Id",
    accessor: "CompanyId"
  }
];

export const DRIVER_COLUMNS = [
  {
    Header: "Employee Id",
    accessor: "EmployeeId"
  },
  {
    Header: "Last Name",
    accessor: "LastName"
  },
  {
    Header: "First Name",
    accessor: "FirstName"
  },
  {
    Header: "MI",
    accessor: "MiddleName"
  },
  {
    Header: "Active",
    accessor: "Active"
  },

  {
    Header: "Address 1",
    accessor: "Address1"
  },
  {
    Header: "Address 2",
    accessor: "Address2"
  },
  {
    Header: "City",
    accessor: "City"
  },
  {
    Header: "State",
    accessor: "State"
  },
  {
    Header: "Zip Code",
    accessor: "ZipCode"
  },
  {
    Header: "Country",
    accessor: "Country"
  },
  {
    Header: "Home Phone No",
    accessor: "HomePhoneNo"
  },
  {
    Header: "Cell Phone No",
    accessor: "CellPhoneNo"
  },
  {
    Header: "Contact Preference",
    accessor: "ContactPreference.CodeDescription",
    id: "ContactPreference"
  },
  {
    Header: "Employee Type",
    accessor: "EmployeeType.CodeDescription"
  },
  {
    Header: "Driver Flag",
    accessor: "DriverFlag"
  },
  {
    Header: "Seniority Date",
    accessor: "SeniorityDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Seniority No",
    accessor: "SeniorityNo"
  },
  {
    Header: "Supervisor",
    accessor: "Supervisor",
    Cell: ({ cell }) =>
      cell.value ? `${cell.value.LastName}, ${cell.value.FirstName}` : null
  },
  {
    Header: "ELD Status",
    accessor: "ELDStatus.CodeDescription"
  },
  {
    Header: "Alternate Phone No",
    accessor: "AlternatePhoneNo"
  },
  {
    Header: "Emergency PhoneNo",
    accessor: "EmergencyPhoneNo"
  },
  {
    Header: "Emergency Contact",
    accessor: "EmergencyContact"
  },
  {
    Header: "Emergency Relationship",
    accessor: "EmergencyRelationship"
  },
  {
    Header: "Email 1",
    accessor: "Email1"
  },
  {
    Header: "Email 2",
    accessor: "Email2"
  },
  {
    Header: "Veteran",
    accessor: "Veteran"
  },
  {
    Header: "Ethnicity",
    accessor: "Ethnicity.CodeDescription"
  }
];
